// Meetstandaardvragen (MSI) horen op ELK meetmoment gesteld te worden: een
// MSI-effect wordt afgemeten aan het verschil tussen een voor- en een nameting,
// dus een effect dat maar op één meetmoment gemeten is, levert geen score op.
// Ze zijn daarom niet per meetmoment uit te zetten — alleen eigen vragen wel.
//
// Twee markeringen, want beide komen in de data voor: `Standard` (string 'true',
// legacy soms boolean) en `MSIId` (de gekoppelde meetstandaard-vraag).
// AI-CONTEXT: See docs/pitfalls.md#database-string-enum-boolean-coercion

/**
 * @param {object} field - Een QuestionnaireFields-doc
 * @returns {boolean} True als de vraag uit de meetstandaard komt en dus altijd
 *   gesteld wordt.
 */
const isStandardQuestion = (field) => (
    field?.Standard === 'true' || field?.Standard === true || Boolean(field?.MSIId)
)

export default isStandardQuestion
